<template>
    <q-layout>

        <!-- Content -->
        <q-page-container>
            <child/>
        </q-page-container>

    </q-layout>
</template>

<script>
    import {
        QLayout,
        QPageContainer
    } from 'quasar-framework'

    export default {
        name: 'BasicLayout',

        components: {
            QLayout,
            QPageContainer
        }
    }
</script>




// WEBPACK FOOTER //
// resources/assets/js/layouts/basic.vue